import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Menu from './components/Menu';
import Slideshow from './components/Slideshow';
import MainContent from './components/MainContent';
import GiftCard from './components/GiftCard';
import Donations from './components/Donations';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function HomePage() {
  return (
    <>
      <Header />
      <Menu />
      <Slideshow />
      <MainContent />
      <Footer />
      <ScrollToTop />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/donations" element={<Donations />} />
          <Route path="/gift-cards" element={<GiftCard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
